function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("circle", {
  cx: 14.5,
  cy: 14.5,
  r: 14.5,
  fill: "#EBEDF5"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M21.5641 9H8.4359C8.0552 9.00045 7.69025 9.1508 7.42102 9.4181C7.15186 9.68545 7.00044 10.0479 7 10.4259V18.5741C7.00045 18.9521 7.15186 19.3145 7.42102 19.5819C7.69025 19.8492 8.0552 19.9996 8.4359 20H21.5641C21.9448 19.9996 22.3098 19.8492 22.579 19.5819C22.8481 19.3145 22.9996 18.9521 23 18.5741V10.4259C22.9996 10.0479 22.8481 9.68545 22.579 9.4181C22.3098 9.15081 21.9448 9.00044 21.5641 9ZM20.8117 10.2222L15 14.5513L9.18828 10.2222H20.8117ZM21.5641 18.7778H8.4359C8.32263 18.7778 8.23077 18.6866 8.23077 18.5741V11.037L14.6308 15.8037C14.7373 15.883 14.8669 15.9259 15 15.9259C15.1331 15.9259 15.2627 15.883 15.3692 15.8037L21.7692 11.037V18.5741C21.7692 18.6281 21.7476 18.6799 21.7092 18.7181C21.6707 18.7563 21.6185 18.7778 21.5641 18.7778Z",
  fill: "#4290F3"
});

var _ref4 = /*#__PURE__*/React.createElement("rect", {
  x: 8,
  y: 10,
  width: 14,
  height: 9,
  fill: "#4081EB",
  fillOpacity: 0.3
});

function SvgEmail(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 29,
    height: 29,
    viewBox: "0 0 29 29",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmail);
export default __webpack_public_path__ + "static/media/email.c88bb4ca.svg";
export { ForwardRef as ReactComponent };